import axios, { AxiosError, AxiosRequestConfig } from 'axios';
// import jwtInterceptor from '../../helper/jtwInterceptor';

interface AxiosBaseQueryArgs {
	url: string;
	method: AxiosRequestConfig['method'];
	data?: AxiosRequestConfig['data'];
	params?: AxiosRequestConfig['params'];
	headers?: AxiosRequestConfig['headers'];
	withCredentials?: AxiosRequestConfig['withCredentials'];
}

const getJwtInterceptor = async () => {
	const module = await import('../../helper/jtwInterceptor');
	return module.default;
};

export const axiosBaseQuery =
	({ baseUrl }: { baseUrl: string }) =>
	async ({ url, method, data, params, headers, withCredentials }: AxiosBaseQueryArgs) => {
		try {
            const jwtInterceptor = await getJwtInterceptor();
			const result = await jwtInterceptor({
				url: baseUrl + url,
				method,
				data,
				params,
				headers: { 'Content-Type': 'application/json', ...(headers ?? {}) },
				...(withCredentials !== false && { withCredentials: true }),
			});
			return { data: result.data };
		} catch (axiosError) {
			const err = axiosError as AxiosError;
			console.log('ERROR in axiosBaseQuery', err);
			return {
				error: {
					status: err.response?.status,
					data: err.response?.data || err.message,
				},
			};
		}
	};

export const axiosNoAuthBaseQuery =
	({ baseUrl }: { baseUrl: string }) =>
	async ({ url, method, data, params, headers, withCredentials }: AxiosBaseQueryArgs) => {
		try {
			// const token = Cookies.get('token');

			const result = await axios({
				url: baseUrl + url,
				method,
				data,
				params,
				headers: {
					'Content-Type': typeof data === 'string' ? 'application/json' : 'application/json',
					...(headers ?? {}),
				},
				...(withCredentials !== false && { withCredentials: true }),
				transformRequest: [(data, headers) => {
					// prevent auto-transformation if it's a raw JSON string
					if (typeof data === 'string') {
						headers['Content-Type'] = 'application/json';
						return data;
					}
					return JSON.stringify(data);
				}],
			});
			return { data: result.data };
		} catch (axiosError) {
			const err = axiosError as AxiosError;
			console.log('ERROR in axiosBaseQuery', err);
			return {
				error: {
					status: err.response?.status,
					data: err.response?.data || err.message,
				},
			};
		}
	};
